export const FeatureFlags = {
    FEATURE_SCHEDULE: "FEATURE_SCHEDULE",
}